import React, { Component } from 'react';

import imgWechat from '../../assets/images/wechat1.png';
import './style.css';

class Footer extends Component {
	constructor(){
		super()
		this.linkOut = this.linkOut.bind(this);
		this.goKfcode = this.goKfcode.bind(this);
	}

	/* linkOut(url){
		const w = window.open('about:blank');
		w.location.href = url;
	} */

	goKfcode(){
		let url = 'http://p.qiao.baidu.com/cps/chat?siteId=13490174&userId=18361197&cp=wx.dali24.com&cr=&cw=';
		window.open(url,'_blank');
	}

	linkOut(url){
		window.open(url,'_blank');
	}

	render(){
		return (
			<div className="lrfooter">
				<footer className="wp100">
					<div className="mx1200 mauto borderb m10b p10b">
						<ul className="clear wp100 firstul">
							<li className="fl wp20">
								<div className="c_666 font_m size_24 m10b disb bigtitle">关于课程</div>
								<ul>
									<li onClick={this.goKfcode}>购课指南</li>
									<li onClick={this.goKfcode}>看课指南</li>
									<li onClick={ev => this.linkOut('http://www.daliedu.cn/topic/chaxun/')}>专业查询</li>
									{/* <li onClick={ev => this.linkOut('http://www.dali24.com/topic/chaxun/')}>专业查询</li> */}
								</ul>
							</li>
							<li className="fl wp20">
								<div className="c_666 font_m size_24 m10b disb bigtitle">帮助中心</div>
								<ul>
									<li onClick={ev => this.linkOut('http://www.daliedu.cn/pay.html')}>在线支付</li>
									<li onClick={ev => this.linkOut('http://www.daliedu.cn/pay.html')}>银行汇款</li>
									<li onClick={ev => this.linkOut('http://www.daliedu.cn/question.html')}>常见问题</li>

									{/* <li onClick={ev => this.linkOut('http://www.dali24.com/pay.html')}>在线支付</li>
									<li onClick={ev => this.linkOut('http://www.dali24.com/pay.html')}>银行汇款</li>
									<li onClick={ev => this.linkOut('http://www.dali24.com/question.html')}>常见问题</li> */}
								</ul>
							</li>
							<li className="fl wp20">
								<div className="c_666 font_m size_24 m10b disb bigtitle">关于我们</div>
								<ul>
									<li onClick={ev => this.linkOut('http://www.daliedu.cn/contact.html')}>公司介绍</li>
									<li onClick={ev => this.linkOut('http://www.daliedu.cn/contact.html')}>联系我们</li>
									<li onClick={ev => this.linkOut('http://www.daliedu.cn/qiye/')}>企业合作</li>

									{/* <li onClick={ev => this.linkOut('http://www.dali24.com/contact.html')}>公司介绍</li>
									<li onClick={ev => this.linkOut('http://www.dali24.com/contact.html')}>联系我们</li>
									<li onClick={ev => this.linkOut('http://www.dali24.com/qiye/')}>企业合作</li> */}
								</ul>
							</li>
							<li className="fl wp20">
								<div className="item">
									<img src={imgWechat} className="disb m10b" alt=""/>
									<div className="c_666">移动端扫码下载</div>
								</div>
							</li>
							<li className="fl wp20">
								<div className="item clear">
									<span className="icon_bg shrx fl"></span>
									<div className="fl font_m c_666">
										<span className="disb m6t m4b">售后热线</span><span>137-1794-0057</span>
									</div>
								</div>
							{/*	<div className="item clear">
									<span className="icon_bg tkwt fl"></span>
									<div className="fl font_m c_666">
										<span className="disb m6t m4b">听课问题</span><span>186-1111-4548</span>
									</div>
								</div>*/}
								<div className="item clear">
									<span className="icon_bg jwzx fl"></span>
									<div className="fl font_m c_666">
										<span className="disb m6t m4b">教务咨询</span><span>137-1794-0057</span>
									</div>
								</div>
								<div className="item clear">
									<span className="icon_bg tszx fl"></span>
									<div className="fl font_m c_666">
										<span className="disb m6t m4b">投诉专线</span><span>400-6666-458</span>
									</div>
								</div>
							</li>
						</ul>
					</div>
					<div className="size_14 textc m6b">版权所有 <span aria-label="img" role="img">©️</span>2012-2019 北京大立立德教育科技有限公司</div>
					<div className="size_14 textc">京ICP备11012638号    增值电信业务经营许可证：京B2-20191274 </div>
				</footer>
			</div>
		)
	}
}


export default Footer;
